import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { logEvent } from "./utils/logger";

// Capture des erreurs JS non attrapées (CRITICAL)
window.addEventListener("error", (event) => {
  logEvent("CRITICAL", "SYSTEM", "Uncaught Fatal Exception", {
    error: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack || null,
  });
});

// Capture des Promises rejetées non gérées (CRITICAL)
window.addEventListener("unhandledrejection", (event) => {
  logEvent("CRITICAL", "SYSTEM", "Unhandled Promise Rejection", {
    reason: event.reason?.toString() || "Unknown",
    stack: event.reason?.stack || null,
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  // </React.StrictMode>
);

reportWebVitals();
